var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lms__superadmin_users_profile_edit_activitylog_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'eventTitle',
                title: 'Event',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'createdAt',
                title: 'Date time',
                type: 'date',
                sortable: true,
                queryable: true
            },
            {
                key: 'description',
                title: 'Description',
                type: 'string',
                sortable: true
            }
        ],"items":_vm.items,"empty-state-title":'Any training user completes will be shown here',"component-table-item":_vm.LmsSuperadminUsersProfileEditActivityLogTableItem},on:{"emit-sort":_vm.handleSort}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }